module.exports = __webpack_public_path__ + "img/kh.9f416b66.png";